import ExcelJS from 'exceljs';
import useGlobalState from "@vighnesh153/use-global-state";
import { ACCESSORS_PLANOGRAMS, ACCESSORS_VALUES_PLANOGRAMS } from './DataFormat';
import axios from 'axios';
import { useState } from 'react';
import PlanogramsTableComponent, { tableSelectionChanged } from './table/planograms';
import { BlockUI, UnblockUI, Notify, APIURL, UnblockUIError, GetSortOrder, GetToken } from './Helper';
import { BiDownload, BiPlusCircle, BiTrash } from 'react-icons/bi';
import SearchPlanograms from './SearchPlanograms';
import MiniSignal from 'mini-signals';

export const projectPlanogramsUpdated = new MiniSignal();

const Planograms = ({ data, isAllPlanograms, isUpload }) => {
    const [user] = useGlobalState("user");
    const [project] = useGlobalState("project");
    const [downloadEnabled, setDownloadEnabled] = useState(false);
    const [allPlanograms, setAllPlanograms] = useState(null);

    const token = GetToken();

    if (data && data !== allPlanograms) {
        data.sort(GetSortOrder("img"));
        setAllPlanograms(data);
    }
        
    tableSelectionChanged.add((data) => {
        const btnDownload = document.getElementById('planogramsDownload');
        const btnAddToProject = document.getElementById('addToProject');
        const planogramsDelete = document.getElementById('planogramsDelete');
        
        if (data > 0) {
            if (btnDownload) {
                setDownloadEnabled(true);
                btnDownload.style.opacity = 1;
            }
            if (planogramsDelete) {
                planogramsDelete.style.opacity = 1;
            }
            if (btnAddToProject) {
                btnAddToProject.style.opacity = 1;
            }
        } else {
            if (btnDownload) {
                setDownloadEnabled(false);
                btnDownload.style.opacity = 0.4;
            }
            if (planogramsDelete) {
                planogramsDelete.style.opacity = 0.4;
            }
            if (btnAddToProject) {
                btnAddToProject.style.opacity = 0.4;
            }
        }
    });

    const downloadSelectedPlanograms = (e) => {
        if (document.getElementById('planogramsForUpload')) {
            const planogramsForUpload = JSON.parse(document.getElementById('planogramsForUpload').innerText);
            if (planogramsForUpload.length === 0) {
                e.preventDefault();
                return;
            }
            BlockUI({
                title: "Please wait!",
                message: "Generating data...",
                position: "top-center",
                type: "info",
                duration: 2000,
                pauseOnHover: false
            });

            //let zip = new JSZip();
            let workbook = new ExcelJS.Workbook();
            workbook.creator = 'Eyesee web portal';
            workbook.lastModifiedBy = user.user_name;
            workbook.created = new Date();
            const worksheet = workbook.addWorksheet('List');
            const columns = [];
            const columnWidths = [15, 15, 15, 15, 15, 15, 50, 50, 50, 50, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20];
            ACCESSORS_VALUES_PLANOGRAMS.forEach((entry, i) => {
                columns.push({
                    header: entry,
                    key: ACCESSORS_PLANOGRAMS[i],
                    width: columnWidths[i]
                });
            });
            worksheet.columns = columns;
            worksheet.getRow(1).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'ffff0000' }                
            };
            worksheet.getRow(1).font = {
                name: 'Calibri',
                color: { argb: 'ffffff' },
                family: 2,
                bold: true
            };            

            const imagesToDownload = {};
            Object.keys(planogramsForUpload).forEach((key, i) => {
                let entry = planogramsForUpload[key];
                imagesToDownload[i] = entry.img;
                delete entry._id;
                worksheet.addRow(entry);                
            });

            workbook.xlsx.writeBuffer().then(buffer => {
                const blobPlanograms = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });                

                const json = JSON.stringify(imagesToDownload);
                const blob = new Blob([json], {
                    type: 'application/json'
                });
                const data = new FormData();
                data.append("file[]", blob, "planograms.json");
                data.append("file[]", blobPlanograms, "planograms.xlsx");

                let progDiv = document.createElement('div');
                progDiv.id = "downloadProgressContainer";
                progDiv.innerHTML = "<div id='downloadProgressBar'></div><span style='position: relative'>Downloading...</span>";
                document.body.appendChild(progDiv);

                axios.post(APIURL + "downloadFiles.php", data).then(res => {
                    if (res.status === 200 && res.data.msg === "Success") {
                        const fileData = new FormData();
                        fileData.set("file", res.data.filename);
                        axios.post(APIURL + "getf.php", fileData, {
                            responseType: 'blob',
                            onDownloadProgress: progressEvent => {
                                const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                document.getElementById('downloadProgressBar').style.width = percentage + "%";
                            }
                        }).then((r) => {
                            const date = new Date();
                            let fileName = 'plano_' + (project ? project.name + '_' : '_') + date.toLocaleDateString() + '_' + date.toLocaleTimeString() + '.zip';
                            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                                window.navigator.msSaveOrOpenBlob(new Blob([r.data],
                                        { type: 'application/zip' }
                                    ),
                                    fileName
                                );
                            } else {
                                const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/zip' }));
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download', fileName);
                                document.body.appendChild(link);
                                link.click();
                                document.getElementById('downloadProgressContainer').remove();
                                UnblockUI();
                                // delete file on server
                                axios.get(APIURL + 'project.php?action=delzip&file=' + res.data.filename).then(r => {});
                            }
                        });
                    } else {
                        document.getElementById('downloadProgressContainer').remove();
                        UnblockUIError(res.status);
                    }
                }).catch(err => {
                    document.getElementById('downloadProgressContainer').remove();
                    UnblockUIError(err);
                });
                
            });
            
        }
    };

    const addToCurrentProject = (e) => {
        const planogramsForUpload = JSON.parse(document.getElementById('planogramsForUpload').innerText);
        if (planogramsForUpload.length === 0) {
            e.preventDefault();
            return;
        }
        BlockUI();
        let planograms = '';
        Object.keys(planogramsForUpload).forEach((key, i) => {
            planograms += planogramsForUpload[key]._id + (i === planogramsForUpload.length - 1 ? '' : ',');
        });
        axios.get(APIURL + 'project.php?action=apl&id=' + project.id + '&plnrs=' + planograms + '&t=' + token).then((response) => {
            const data = response.data;
            if (data.added.length > 0) {
                Notify({
                    title: "Success",
                    message: data.added.length + " planogram(s) added to active project!",
                    type: "success"
                });
            }
            if (data.notadded.length > 0) {
                Notify({
                    title: data.notadded.length + " planogram(s) not added as they already exist in project!",
                    message: data.notadded.join(' , '),
                    type: "warning"
                });
            }
            UnblockUI();
        }).catch((error) => {
            console.log(error);
            UnblockUIError(error);
        });
    };

    const deleteSelectedPlanograms = (e) => {
        if (document.getElementById('planogramsForUpload')) {
            const planogramsForUpload = JSON.parse(document.getElementById('planogramsForUpload').innerText);
            if (planogramsForUpload.length === 0) {
                e.preventDefault();
                return;
            }
            let planogramsIDs = '';
            Object.keys(planogramsForUpload).forEach((key, i) => {
                let entry = planogramsForUpload[key];
                planogramsIDs += entry._id;
                if (i < planogramsForUpload.length - 1) {
                    planogramsIDs += ',';
                }
            });

            let confirmMsg = "Are you sure you want to delete selected planograms? This will delete these planograms from all projects!";
            let getURL = `${APIURL}planograms.php?action=dp&ids=${planogramsIDs}&t=${token}`;
            
            if (!isAllPlanograms) {
                confirmMsg = "Are you sure you want to delete selected planograms from active project?";
                getURL = `${APIURL}project.php?action=dpl&id=${project.id}&plns=${planogramsIDs}&t=${token}`;
            }

            if (window.confirm(confirmMsg)) {
                BlockUI({
                    title: "Please wait!",
                    message: "Deleting data...",
                    position: "top-center",
                    type: "info",
                    duration: 2000,
                    pauseOnHover: false
                });
                axios.get(getURL).then(res => {
                    if (res.status === 200) {
                        Notify({
                            title: "Success",
                            message: "Planograms deleted successfully!",
                            type: "success",
                            duration: 2000,
                            position: "top-center"
                        });
                        const planogramsIDsArray = planogramsIDs.split(',');
                        const updatedShelves = allPlanograms.filter(planogram => !planogramsIDsArray.includes(planogram._id + ""));
                        projectPlanogramsUpdated.dispatch({ data: updatedShelves, all: isAllPlanograms });
                        UnblockUI();
                    } else {
                        UnblockUIError(res.statusText);
                    }
                }).catch(err => {
                    UnblockUIError(err);
                });
            }
        }
    };
    
    return (
        <div className="App container mx-auto mt-3 font-thin">
            {
                !isUpload && allPlanograms && allPlanograms.length > 0 &&
                <SearchPlanograms onSearch={(data) => {
                    projectPlanogramsUpdated.dispatch({ data: data, all: isAllPlanograms });
                }} />
            }
            <div className="relative pr-8">
                <div className="absolute right-1" style={{ marginTop: '-50px', zIndex: '101' }}>
                    {
                        project != null && isAllPlanograms &&
                        <div id="addToProject" type="button" className={`inline-block p-2 mr-2 cursor-pointer text-pink-500 self-center text-center font-medium disabled:opacity-50 float-right active:text-gray text-center text-3xl ${downloadEnabled ? "cursor-pointer active:text-red" : "cursor-not-allowed"}`} onClick={(e) => { addToCurrentProject(e) }}><BiPlusCircle className="inline-block -mt-1 ml-1" /></div>
                    }
                    {
                        !isUpload &&
                        <div id="planogramsDownload" className={`inline-block p-2 mr-2 text-black self-center disabled:opacity-50 float-right text-center active:text-gray text-center text-3xl ${downloadEnabled ? "cursor-pointer active:text-gray" : "cursor-not-allowed"}`} onClick={(e) => { downloadSelectedPlanograms(e) }}><BiDownload className="inline-block -mt-1 ml-1" /></div>
                    }
                    {
                        !isUpload && (!isAllPlanograms || user.isAdmin) &&
                        <div id="planogramsDelete" className={`mr-2 p-2 inline-block text-black self-center disabled:opacity-50 float-right active:text-gray text-center text-3xl ${downloadEnabled ? "cursor-pointer active:text-gray" : "cursor-not-allowed"}`} onClick={(e) => { deleteSelectedPlanograms(e) }}><BiTrash className="inline-block -mt-1 ml-2" /></div>
                    }
                </div>
            </div>
            {
                allPlanograms && allPlanograms.length > 0 &&
                <div>
                    <PlanogramsTableComponent providedData={allPlanograms} />
                </div>
            }
        </div>
    );
};

export default Planograms;